exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1V9eK {\n  padding: 40px 20px;\n  background-color: #F6F4F0;\n}\n._1V9eK .V-oTC {\n  width: 80px;\n}\n._1V9eK ._1V6_f {\n  padding: 10px 20px;\n}\n.uk-button-primary {\n  background-color: #a89a72;\n  border-color: #a89a72;\n  color: #fff;\n}\n.uk-button-primary:hover {\n  background-color: #fff;\n  color: #a89a72;\n}\n", ""]);

// Exports
exports.locals = {
	"logoContainer": "_1V9eK",
	"logo": "V-oTC",
	"text": "_1V6_f"
};